<template>
  <section class="section section-soft">
    <div class="container">
      <div class="section-head" v-reveal>
        <span class="section-eyebrow">OUR PROCESS</span>
        <h2 class="section-title">透明的<em>五步开发流程</em></h2>
        <p class="section-sub">从需求到上线，每一步都有明确交付物，让您全程心中有数。</p>
      </div>

      <div class="flow">
        <div v-for="(f, i) in flow" :key="f.title" class="flow-step" v-reveal="{ delay: i * 110 }">
          <div class="step-head">
            <span class="step-num num">{{ String(i + 1).padStart(2, '0') }}</span>
            <span v-if="i < flow.length - 1" class="step-line"></span>
          </div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const flow = [
  { title: '需求沟通', desc: '倾听业务诉求，梳理功能清单，输出需求文档与报价。' },
  { title: '方案设计', desc: '原型交互 + 视觉设计，确认页面细节与用户体验。' },
  { title: '开发实现', desc: '前后端并行开发，每周同步进度，里程碑节点验收。' },
  { title: '测试验收', desc: '多端真机测试、性能与安全检测，提交验收报告。' },
  { title: '上线交付', desc: '部署上线、应用商店上架，交付源码与操作文档。' }
]
</script>

<style scoped>
.flow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.flow-step {
  position: relative;
  background: #fff;
  border: 1px solid var(--hl-line);
  border-radius: var(--radius);
  padding: 26px 22px;
  transition: all 0.35s ease;
}

.flow-step:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow);
}

.step-head {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.step-num {
  font-size: 26px;
  font-weight: 700;
  color: var(--hl-blue);
  background: linear-gradient(135deg, rgba(11, 92, 255, 0.1), rgba(53, 194, 247, 0.12));
  border-radius: 12px;
  padding: 4px 10px;
}

.step-line {
  flex: 1;
  height: 2px;
  margin-left: 14px;
  background: repeating-linear-gradient(
    90deg,
    var(--hl-cyan) 0 6px,
    transparent 6px 12px
  );
  opacity: 0.4;
}

.flow-step h3 {
  font-size: 17px;
  font-weight: 700;
  color: var(--hl-text);
}

.flow-step p {
  margin-top: 10px;
  font-size: 13.5px;
  color: var(--hl-text-2);
  line-height: 1.8;
}

@media (max-width: 992px) {
  .flow {
    grid-template-columns: repeat(2, 1fr);
  }
  .step-line {
    display: none;
  }
}

@media (max-width: 640px) {
  .flow {
    grid-template-columns: 1fr;
  }
}
</style>
